import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useVerticalListQuery } from "Settings/Modules/OrderSetup/Api/Query/useVerticalListQuery";
import { VerticalSelectCard } from "Settings/Modules/OrderSetup/Components/VerticalSelectCard";
import { SettingsPaths } from "Settings/Routes/Routing";
import { Loading } from "Shared/Components/Loading/Loading";
import { Grid2, Typography } from "@mui/material";
import type { FC } from "react";
import { Navigate, useNavigate } from "react-router";

type Props = {
	selectedMarketId?: number;
	selectedVerticalId?: number;
};

const orderSetupResource = Resources.base.orderSetup.shared;

export const OrderSetupVerticalSelectWidget: FC<Props> = ({
	selectedMarketId,
	selectedVerticalId,
}) => {
	if (selectedMarketId && selectedVerticalId) {
		<Navigate
			to={SettingsPaths.OrderSetupEdit.path(
				selectedMarketId,
				selectedVerticalId,
			)}
		/>;
	}

	const { t } = useResource();
	const { data: verticals, isLoading } = useVerticalListQuery();

	const navigate = useNavigate();
	const handleSelectVertical = (verticalId: number) => {
		selectedMarketId &&
			navigate(
				SettingsPaths.VerticalSetupSelect.path(selectedMarketId, verticalId),
			);
	};

	return (
		<>
			<Typography variant="h3">{t(orderSetupResource.verticals)}</Typography>
			{isLoading && <Loading />}
			<Grid2 container spacing={2} mt={2}>
				{verticals?.map((vertical, index) => (
					<Grid2 size={{ xs: 6, sm: 4, md: 3 }} key={vertical.id}>
						<VerticalSelectCard
							vertical={vertical}
							index={index}
							onClick={() => {
								handleSelectVertical(vertical.id);
							}}
						/>
					</Grid2>
				))}
			</Grid2>
		</>
	);
};
